import { BAR, LINE, PIE } from "src/components/Charts/types";

export class QuestionAdapter {
  static adaptQuestions(perguntasRelatorio) {
    return perguntasRelatorio.map((pergunta, index) => ({
      id: pergunta.id,
      enunciado: pergunta.enunciado,
      index: index + 1,
      graficos: this.adaptGraficos(pergunta.dados_plotagem_relatorio, pergunta.id),
    }));
  }

  static adaptGraficos(dadosPlotagem, perguntaId) {
    const graficos = [];

    dadosPlotagem.forEach((plot) => {
      const tipo = plot.resultado_type_def;

      if (tipo === "CRUZAMENTO_SIMPLES") {
        const perguntaPrincipal = plot.data.perguntas_principais ? plot.data.perguntas_principais[0] : null;
        const perguntasCruzadas = perguntaPrincipal ? perguntaPrincipal.perguntas_cruzadas : [];

        graficos.push({
          tipo,
          id: `${perguntaId}-1`,
          title: 'Cruzamento simples',
          checked: true,
          perguntas: perguntasCruzadas.map((p) => ({
            checked: true,
            titulo_pergunta: p.enunciado,
            id_pergunta: p.id,
          })),
        });
      } else if (tipo === "EVOLUTIVO") {
        // Verifica se já existe um gráfico do tipo EVOLUTIVO
        const evolutivoGrafico = graficos.find((g) => g.tipo === "EVOLUTIVO");

        if (evolutivoGrafico) {
          // Adiciona as configurações ao gráfico existente
          evolutivoGrafico.configuracoes.push({
            checked: true,
            titulo_configuracao: plot.data.titulo_configuracao,
            id_configuracao: plot.data.id_configuracao,
          });
        } else {
          // Cria um novo gráfico do tipo EVOLUTIVO
          graficos.push({
            tipo,
            id: `${perguntaId}-2`,
            title: 'Gráfico evolutivo',
            checked: true,
            render: LINE,
            configuracoes: [
              {
                checked: true,
                titulo_configuracao: plot.data.titulo_configuracao,
                id_configuracao: plot.data.id_configuracao,
              },
            ],
          });
        }
      } else if (tipo === "GERAIS") {
        graficos.push({
          tipo,
          id: `${perguntaId}-3`,
          title: 'Gráfico simples',
          render: PIE,
          checked: true,
          pergunta: plot.data.perguntas[0]?.id || null,
        });
      }
    });

    return graficos;
  }
}